module.exports = __webpack_public_path__ + "static/transparency_money-44800f970ae2e7f084f2e47d3cd3c328.png";